import _ from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';

import MaxWidthContainer from 'components/MaxWidthContainer';
import classnames from 'classnames';

import { ChevronLeftSvg } from 'components/SorraSvg';
// import { ranks } from 'utils/voting2024';
import { useAppLaunch } from 'contexts/AppLaunch';
// import useRWD from 'hooks/useRWD';
import { results } from 'utils/voting2025';

import useSWR from 'swr';

import { swrGoFetcher } from 'utils/go_api';
import api, { swrFetcher } from 'utils/api';

const { useState, useEffect, useRef, forwardRef } = React;

const ProductCard = (props) => {
  const router = useRouter();
  const { idx, rankIdx, productId, showBorder = false } = props;

  const { key } = results[rankIdx];

  const { productOriginMap } = useAppLaunch();

  const { data: product } = useSWR(
    `/api/beauty-award/product/${productId}`,
    swrFetcher,
    {
      revalidateOnFocus: false,
    }
  );

  if (product && product.facts && product.facts.length > 0) {
    console.log(product.facts);
  }

  // const product = overview ? overview.data : null;
  // console.log({ overview });

  // const { productName, brandName } = props;
  const facts = _.get(product, 'facts', []);
  const origin = _.get(product, 'origin');
  const image = _.get(product, 'images[0].url', '');
  const brandName = _.get(product, 'brand.name', '');
  const productName = _.get(product, 'name', '');
  const enName = _.get(product, 'en_name', '');
  const displayName = !_.isEmpty(enName)
    ? `${enName} ${productName}`
    : productName;
  const review = _.get(product, 'reviews.0', []);
  const reviews = _.take(_.get(product, 'reviews', []), 2);
  // const factors = _.get(review, 'factors', []);

  const productOrigin = productOriginMap[origin];

  const factCount = facts.length + (productOrigin ? 1 : 0);
  const factsObj = [];
  if (productOrigin) {
    factsObj.push({
      name: productOrigin.name,
    });
  }
  facts.forEach((fact) => {
    factsObj.push(fact);
  });

  return (
    <div
      className={classnames('py-0 lg:py-6', {
        'border-gray-[#D1D5DB] border-b': showBorder,
      })}
    >
      {/* desktop */}
      <div
        style={{
          height: '256px',
        }}
        className="relative hidden w-full shrink-0 cursor-pointer gap-x-8 py-4 pl-[80px] pr-10 lg:flex"
        onClick={() => {
          router.push(`/product/${productId}`);
        }}
      >
        <div className="relative h-[208px] w-[190px] shrink-0">
          <img
            src={image ? image : '/images/placeholders/product.png'}
            className="h-full w-full object-contain object-bottom"
          />
          <img
            className="absolute bottom-0 left-0 aspect-[72/63] w-[72px] object-contain"
            // src={`/images/2024/result/categories/calming/Rank4-10.png`}
            src={`/images/beauty-award/2025/badges/${key}-${idx > 2 ? '4-10' : idx + 1}.png`}
          />
        </div>
        <div className="flex min-w-0 grow flex-col justify-center">
          <p className="shrink-0 truncate text-base text-[#4A4A4A]">
            {brandName}
          </p>
          <p className="shrink-0 truncate text-2xl font-medium text-[#111928]">
            {displayName}
          </p>
          <div className="mt-4 flex w-full gap-x-2 text-base font-medium">
            {factsObj.map((fact) => {
              const { name, bg_color, text_color } = fact;
              return (
                <div
                  key={name}
                  style={{
                    background: bg_color || 'rgba(252, 225, 229, 0.5)',
                    color: text_color || '#f16b7c',
                  }}
                  className="rounded-md px-2 py-1 text-[#f16b7c]"
                >
                  {name}
                </div>
              );
            })}
          </div>
          {!_.isEmpty(reviews) && (
            <div className="mt-4 flex w-full flex-col gap-y-2">
              {_.take(reviews, 2).map((review) => {
                const { id, sorra_user } = review;
                const { name = '' } = sorra_user || {};

                const avatarUrl = _.get(sorra_user, 'picture', '');
                return (
                  <div
                    key={id}
                    className="flex w-full flex-row items-center gap-x-3 overflow-hidden py-1"
                  >
                    <div className="h-7 w-7 shrink-0 overflow-hidden rounded-full bg-[#D6DDFB]">
                      {!_.isEmpty(avatarUrl) ? (
                        <img
                          src={avatarUrl}
                          className="h-full w-full object-cover"
                        />
                      ) : (
                        name && (
                          <div className="flex h-full w-full items-center justify-center">
                            <p className="text-xs font-medium text-[#5882FF]">
                              {_.upperCase(name[0])}
                            </p>
                          </div>
                        )
                      )}
                    </div>
                    <div className="line-clamp-2 min-w-0 grow text-base font-normal text-[#4A4A4A]">
                      {review.comment || ''}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div
          style={{
            width: '72px',
            height: '72px',
          }}
          className="absolute left-0 top-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 68 68"
            fill="none"
          >
            <path
              d="M5.12132 66.8787C3.23143 68.7686 8.02891e-06 67.4301 8.26257e-06 64.7574L6.03216e-06 3.00015C6.177e-06 1.3433 1.34315 0.00015404 3 0.000146556L64.7573 1.46256e-05C67.4301 1.48593e-05 68.7686 3.23144 66.8787 5.12134L36 36L5.12132 66.8787Z"
              fill={
                idx == 0
                  ? '#FABE3D'
                  : idx == 1
                    ? '#C6C6C6'
                    : idx == 2
                      ? '#E49546'
                      : '#F16B7C'
              }
            />
          </svg>
          <div className="absolute left-[5px] top-[5px] flex flex-row items-end font-rubik">
            <div className="flex flex-col items-center">
              <img
                style={{
                  width: '13px',
                  height: '10px',
                }}
                src="/images/2024/result/mobile/crown.png"
                className="object-contain"
              />
              <p
                style={{
                  fontSize: idx < 9 ? '24px' : '20px',
                }}
                className="font-medium text-white"
              >
                {idx + 1}
              </p>
            </div>
            <p
              style={{
                paddingBottom: '7px',
                marginLeft: '1px',
              }}
              className="text-[8px] font-semibold text-white"
            >
              位
            </p>
          </div>
        </div>
      </div>
      {/* mobile */}
      <div className="flex flex-col gap-y-4 py-4 lg:hidden">
        <div
          className="relative flex w-full shrink-0 gap-x-3 pl-[18px]"
          onClick={() => {
            router.push(`/product/${productId}`);
          }}
        >
          <div className="relative shrink-0 pt-2">
            <img
              src={image ? image : '/images/placeholders/product.png'}
              className="h-[109px] w-[100px] object-contain object-bottom"
            />
            <img
              className="absolute -left-[18px] bottom-0 h-[41px] w-[47px] object-contain"
              src={`/images/beauty-award/2025/badges/${key}-${idx > 2 ? '4-10' : idx + 1}.png`}
            />
          </div>
          <div className="flex min-w-0 grow flex-col justify-start gap-y-1.5">
            <p className="truncate text-sm text-[#4A4A4A]">{brandName}</p>
            <p className="truncate text-base font-medium text-[#111928]">
              {productName}
            </p>
            {!_.isEmpty(enName) && (
              <p className="truncate text-base font-medium text-[#111928]">
                {enName}
              </p>
            )}
            <div className="mt-3 flex w-full gap-x-2 text-xs font-medium">
              {_.take(factsObj, factCount > 2 ? 1 : 2).map((fact) => {
                const { name, bg_color, text_color } = fact;
                return (
                  <div
                    key={name}
                    style={{
                      background: bg_color || 'rgba(252, 225, 229, 0.5)',
                      color: text_color || '#f16b7c',
                    }}
                    className="rounded-md px-2 py-1 text-[#f16b7c]"
                  >
                    {name}
                  </div>
                );
              })}
              {factCount > 2 && (
                <div
                  style={{
                    background: '#F5F5F5',
                    color: '#4A4A4A',
                  }}
                  className="rounded-md px-2 py-1"
                >
                  +{factCount - 1}
                </div>
              )}
            </div>
          </div>
          <div className="absolute left-0 top-0 h-15 w-15">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 68 68"
              fill="none"
            >
              <path
                d="M5.12132 66.8787C3.23143 68.7686 8.02891e-06 67.4301 8.26257e-06 64.7574L6.03216e-06 3.00015C6.177e-06 1.3433 1.34315 0.00015404 3 0.000146556L64.7573 1.46256e-05C67.4301 1.48593e-05 68.7686 3.23144 66.8787 5.12134L36 36L5.12132 66.8787Z"
                fill={
                  idx == 0
                    ? '#FABE3D'
                    : idx == 1
                      ? '#C6C6C6'
                      : idx == 2
                        ? '#E49546'
                        : '#F16B7C'
                }
              />
            </svg>
            <div className="absolute left-[5px] top-[5px] flex flex-row items-end font-rubik">
              <div className="flex flex-col items-center">
                <img
                  style={{
                    width: '10px',
                    height: '8px',
                  }}
                  src="/images/2024/result/mobile/crown.png"
                  className="object-contain"
                />
                <p
                  style={{
                    fontSize: '16px',
                  }}
                  className="font-medium text-white"
                >
                  {idx + 1}
                </p>
              </div>
              <p
                style={{
                  paddingBottom: '4px',
                  marginLeft: '1px',
                }}
                className="text-[8px] font-semibold text-white"
              >
                位
              </p>
            </div>
          </div>
        </div>
        {!_.isEmpty(reviews) && (
          <div className="flex w-full flex-col gap-y-2 py-2">
            {_.take(reviews, 1).map((review) => {
              const { id, sorra_user, mask_name } = review;
              const avatarUrl = _.get(sorra_user, 'picture', '');
              return (
                <div
                  key={id}
                  className="flex w-full flex-row items-center gap-x-3 overflow-hidden py-1"
                >
                  <div className="h-7 w-7 shrink-0 overflow-hidden rounded-full bg-[#D6DDFB]">
                    {!_.isEmpty(avatarUrl) ? (
                      <img
                        src={avatarUrl}
                        className="h-full w-full object-cover"
                      />
                    ) : (
                      mask_name && (
                        <div className="flex h-full w-full items-center justify-center">
                          <p className="text-xs font-medium text-[#5882FF]">
                            {_.upperCase(mask_name[0])}
                          </p>
                        </div>
                      )
                    )}
                  </div>
                  <div className="line-clamp-2 min-w-0 grow text-base font-normal text-[#4A4A4A]">
                    {review.comment || ''}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const BeautyAwards2025ResultRanking = (props) => {
  const router = useRouter();

  const [currentRankIdx, setCurrentRankIdx] = useState(0);

  const [showInstruction, setShowInstruction] = useState(false);

  const targetResult = results[currentRankIdx];
  const productIds = targetResult.productIds;

  useEffect(() => {
    const hash = window.location.hash;
    if (!_.isEmpty(hash)) {
      const hashKey = hash.replace('#', '');
      const rankIdx = _.findIndex(results, { key: hashKey });
      if (rankIdx !== -1) {
        setCurrentRankIdx(rankIdx);
        // if (rankItemsRef.current) {
        //   rankItemsRef.current.children[rankIdx].scrollIntoView({
        //     behavior: 'smooth',
        //     inline: 'center',
        //   });
        // }
      }
    }
  }, []);

  return (
    <div
      style={{
        // background: 'rgba(241, 107, 124, 0.05)',
        background:
          'linear-gradient(90deg, #FACBD1 1.2%, #FFF5F6 30.36%, #FACBD1 99.86%)',
      }}
      className="relative flex h-auto w-full flex-col overflow-hidden lg:h-auto lg:px-0"
    >
      <div className="absolute left-1/2 top-0 -translate-x-1/2 opacity-10">
        <svg
          className="hidden lg:block"
          width="2065"
          height="1052"
          viewBox="0 0 2065 1052"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M1309.78 0L1136 1002.01L1239.37 1020.37L1527 0H1309.78Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M755.222 0L929 1002.01L825.632 1020.37L538 0H755.222Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M1668.5 0L1344 999.798H1414.5L2065 0H1668.5Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M396.5 0L721 999.798H650.5L0 0H396.5Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M1181 0L1080 1051.23H989.041L897 0H1181Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
        </svg>
        <svg
          className="block lg:hidden"
          width="783"
          height="448"
          viewBox="0 0 783 448"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M496.63 0L430.738 426.204L469.933 434.013L578.995 0H496.63Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M286.362 0L352.254 426.204L313.06 434.013L203.997 0H286.362Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M632.648 0L509.606 425.263H536.338L782.991 0H632.648Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M150.343 0L273.385 425.263H246.653L0.000305176 0H150.343Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
          <g>
            <path
              d="M447.803 0L409.506 447.138H375.017L340.117 0H447.803Z"
              fill="#FF0B0B"
              fillOpacity="0.6"
            />
          </g>
        </svg>
      </div>
      <div className="mt-[18px] flex w-full justify-center lg:mt-[26px]">
        <img
          className="h-[47px] w-[185px] object-contain lg:h-[38px] lg:w-[194px]"
          src="/images/beauty-award/2025/result_sasaxsorra.png"
        />
      </div>
      <MaxWidthContainer
        noPending
        className="relative mt-[14px] flex justify-center pt-10 lg:mt-1 lg:pt-3"
      >
        <button
          className="absolute left-6 top-0 flex items-center gap-x-3 rounded-full border-[2px] border-sorra-pink bg-white px-4 py-2 lg:left-20 lg:top-0 lg:px-6"
          onClick={() => {
            router.push('/beautyawards2025/result');
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
          >
            <path
              d="M20 8.36328C20.5523 8.36328 21 7.91557 21 7.36328C21 6.811 20.5523 6.36328 20 6.36328V7.36328V8.36328ZM0.292892 6.65617C-0.0976315 7.0467 -0.0976315 7.67986 0.292892 8.07039L6.65685 14.4343C7.04738 14.8249 7.68054 14.8249 8.07107 14.4343C8.46159 14.0438 8.46159 13.4107 8.07107 13.0201L2.41421 7.36328L8.07107 1.70643C8.46159 1.3159 8.46159 0.682738 8.07107 0.292213C7.68054 -0.0983109 7.04738 -0.0983109 6.65685 0.292213L0.292892 6.65617ZM20 7.36328V6.36328L1 6.36328V7.36328V8.36328L20 8.36328V7.36328Z"
              fill="#F16B7C"
            />
          </svg>
          <p className="text-base font-semibold text-sorra-pink lg:text-2xl">
            返回
          </p>
        </button>
        <button
          className="absolute right-[26px] top-0 flex items-center gap-x-3 rounded-full bg-sorra-pink px-4 py-2 lg:right-[91px] lg:top-0 lg:px-7 lg:py-3"
          onClick={() => {}}
        >
          <p className="text-base font-semibold text-white lg:text-lg">
            前往SORRA主頁
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M0.292893 12.2929C-0.0976311 12.6834 -0.0976311 13.3166 0.292893 13.7071C0.683418 14.0976 1.31658 14.0976 1.70711 13.7071L1 13L0.292893 12.2929ZM14 0.999999C14 0.447714 13.5523 -8.61581e-07 13 -1.11446e-06L4 -3.13672e-07C3.44772 -6.50847e-07 3 0.447715 3 0.999999C3 1.55228 3.44772 2 4 2L12 2L12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10L14 0.999999ZM1 13L1.70711 13.7071L13.7071 1.70711L13 0.999999L12.2929 0.292893L0.292893 12.2929L1 13Z"
              fill="white"
            />
          </svg>
        </button>
        <img
          className="hidden h-[124px] w-[139px] lg:block"
          src="/images/beauty-award/2025/badges/badge.png"
        />
        {/* <div className="block h-10 lg:hidden" /> */}
      </MaxWidthContainer>
      <div className="relative flex items-center justify-between px-5 pt-[30px] lg:justify-center lg:pt-9">
        <div className="flex grow flex-col lg:grow-0">
          <p className="font-jinxuanlatte text-[24px] font-extrabold lg:text-[48px]">
            分類排名榜
          </p>
          <div
            className="flex cursor-pointer items-center gap-x-1 lg:hidden"
            onClick={() => {
              setShowInstruction((prev) => {
                return !prev;
              });
            }}
          >
            <img
              src="/svgs/information-circle-pink.svg"
              className="h-4 w-4"
            ></img>
            <div className="text-sm font-medium text-sorra-pink">
              Sorra 如何決定排行榜名次？
            </div>
          </div>
        </div>
        <img
          className="block h-[84px] w-[94px] shrink-0 lg:hidden"
          src="/images/beauty-award/2025/badges/badge.png"
        />
      </div>
      <div className="relative mt-2 hidden justify-center lg:flex">
        <div
          className="flex cursor-pointer items-center gap-x-1"
          onClick={() => {
            setShowInstruction((prev) => {
              return !prev;
            });
          }}
        >
          <img
            src="/svgs/information-circle-pink.svg"
            className="h-4 w-4"
          ></img>
          <div className="text-sm font-medium text-sorra-pink">
            Sorra 如何決定排行榜名次？
          </div>
        </div>
      </div>
      {showInstruction && (
        <div className="relative mt-[18px] flex justify-center px-4">
          <div className="rounded-lg bg-white px-3 py-2 text-left text-sm font-medium text-[#111928] before:absolute before:left-1/4 before:top-0 before:-translate-x-1/2 before:-translate-y-full before:border-b-[10px] before:border-l-[10px] before:border-r-[10px] before:border-b-white before:border-l-transparent before:border-r-transparent before:content-[''] lg:text-center lg:before:left-1/2">
            本次大賞透過 70% 公眾投票（3,844 份有效問卷）與 30% Sasa
            真實銷售數據的「雙軌計分機制」，
            <br className="hidden lg:block" />
            杜絕了單純依靠網絡聲量或單一銷售渠道的偏差，反映出最真實的香港美妝市場面貌。
          </div>
        </div>
      )}
      <MaxWidthContainer
        noPending
        className="mt-[18px] px-4 pb-[76px] lg:mt-9 lg:px-[140px]"
      >
        <div
          style={{
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.10)',
          }}
          className="relative flex w-full flex-col rounded-[16px] bg-white px-4 py-4 lg:rounded-[32px] lg:px-10 lg:py-6"
        >
          <div className="relative w-full">
            <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#E7E7E7]" />
            <div className="no-scrollbar relative flex justify-start gap-x-8 overflow-x-auto px-1.5">
              {results.map((result, idx) => {
                const { name } = result;
                const selected = idx === currentRankIdx;
                return (
                  <div
                    key={name}
                    className={classnames(
                      'relative flex shrink-0 cursor-pointer flex-col items-center text-base lg:text-[20px]',
                      {
                        'font-normal opacity-70': !selected,
                        'font-bold opacity-100': selected,
                      }
                    )}
                    onClick={() => {
                      setCurrentRankIdx(idx);
                      // scrollerRef.current.scrollTo(0, 0, { behavior: 'smooth' });
                    }}
                  >
                    <p className="">{name}</p>
                    {/* <div className="absolute bottom-0 left-0 right-0 h-[3px] w-full rounded-full bg-sorra-pink" /> */}
                    <div
                      className={classnames(
                        'mt-2 h-[3px] w-full rounded-full bg-sorra-pink lg:mt-[15px]',
                        {
                          hidden: !selected,
                        }
                      )}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mt-0 flex flex-col gap-y-6 lg:mt-6">
            {productIds.map((productId, idx) => {
              return (
                <ProductCard
                  key={productId}
                  idx={idx}
                  productId={productId}
                  rankIdx={currentRankIdx}
                  showBorder={idx !== productIds.length - 1}
                  // {...product}
                />
              );
            })}
          </div>
        </div>
      </MaxWidthContainer>
    </div>
  );
};

export default BeautyAwards2025ResultRanking;

// export async function getServerSideProps(ctx) {
//   const { key } = ctx.query;
//   try {
//     const { data: campaigns } = await api.request({
//       method: 'GET',
//       url: `/api/v3/campaigns`,
//     });
//     const targetCampaign = _.find(campaigns, { name: 'BEAUTY_AWARD_2024' });
//     if (targetCampaign || key === 'F5A3302A-E6AB-44E7-ABEB-D41DECD1DCAA') {
//       return {
//         props: {},
//       };
//     } else {
//       return {
//         props: {
//           expired: true,
//         },
//       };
//     }
//   } catch (e) {
//     console.log(e);
//   }
//   return {
//     notFound: true,
//   };
// }
